import { TAppLangItem, TAppLangModule } from './i18nTypes';

// Lang modules in this codebase are exported as concrete object literals (so
// each tag is a distinct property on the type). When the runtime key is a
// dynamic `string` — e.g. an enum tag from the API — TypeScript correctly
// rejects `lang[key]` because the index isn't statically known. This helper
// types the lookup as "look up a known shape by an arbitrary string", which is
// the actual runtime contract, and returns `undefined` for missing keys
// instead of crashing on a chained `.tag` access.
export const langLookup = <T extends TAppLangModule>(
	lang: T,
	key: string | undefined | null,
): TAppLangItem | undefined => {
	if (key === null || key === undefined) return undefined;
	return (lang as TAppLangModule)[key];
};
